import {ChangeDetectorRef, Component, EventEmitter, OnInit} from "@angular/core";
import {GridFilterEvent} from "prod-shared";
import {ProdDialogData, ProdDialogService, ProdDialogType} from "prod-dialog";
import {take} from "rxjs";
import {DipClientFilterService} from "./service/dip-client-filter.service";
import {DipGridFilterDialog} from "./dialog/dip-grid-filter-dialog";
import {ClientFilterProperties} from "./model/client-filter-properties";
import {ClientFilter} from "./model/client-filter";
import {ProdGridComponent} from "prod-grid";

@Component({
  selector: 'dip-grid-filter',
  templateUrl: './dip-grid-filter.html',
  styleUrls: ['./dip-grid-filter.scss']
})
export class DipGridFilter implements OnInit {
  grid: ProdGridComponent;
  clientFilters: ClientFilter[] = [];
  lastActivatedClientFilter: ClientFilter;
  filterEvents: EventEmitter<{ name: GridFilterEvent, value?: any }> = new EventEmitter<{ name: GridFilterEvent, value?: any }>();

  constructor(private prodDialogService: ProdDialogService, private clientFilterService: DipClientFilterService, private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.loadClientFilters();
    this.filterEvents.subscribe(event => {
      if (event.name === GridFilterEvent.ADD) this.loadClientFilters();
    })
  }

  loadClientFilters() {
    this.clientFilters = [];
    this.clientFilterService.getFiltersForComponent(this.grid.parentComponentName).pipe(take(1)).subscribe(filters => {
      filters.data.result.forEach(filter => {
        let properties: ClientFilterProperties[] = [];
        let sorters: { property: string, direction: string }[] = [];
        const json = JSON.parse(filter.jsonFilter);

        json.properties.forEach(property => {
          properties.push(new ClientFilterProperties(
            property.property,
            property.value,
            property.operator)
          )
        });

        json.sorters.forEach(property => {
          sorters.push({property: property.property, direction: property.direction});
        });

        this.clientFilters.push(new ClientFilter(
          filter.id,
          filter.name,
          properties,
          sorters,
          json.limit,
          filter.user,
          filter.organizations)
        );
      });

      this.clientFilters.sort((a, b) => {
        return a.user === null ? 1 : -1;
      });

      this.filterEvents.emit({name: GridFilterEvent.LOAD, value: this.clientFilters});
      this.changeDetectorRef.detectChanges();
    });
  }

  activate(clientFilter: ClientFilter): void {
    this.lastActivatedClientFilter = clientFilter;
    this.filterEvents.emit({
        name: GridFilterEvent.ACTIVATE_CLIENT,
        value: clientFilter
      }
    );
  }

  reset(): void {
    this.lastActivatedClientFilter = undefined;
    this.filterEvents.emit({
        name: GridFilterEvent.RESET
      }
    );
  }

  restore(): void {
    this.lastActivatedClientFilter = undefined;
    this.filterEvents.emit({
        name: GridFilterEvent.RESTORE
      }
    );
  }

  openDialog(): void {
    this.prodDialogService.open(new ProdDialogData({
          type: ProdDialogType.COMPONENT,
          component: DipGridFilterDialog,
          styles: {width: '60%', height: '70%'},
          data: this
        }
      )
    );
  }
}
